// Word (.docx) counterpart of generatePdfFileName. Same naming scheme so the
// Word download sits beside the PDF one: ACO_First_LAST_CV_LANG_keywords.docx
export function generateWordFileName( user, language, keywords ) {

    const firstName = user?.firstName || user?.prenom || 'NoFirstName';
    const lastName = user?.lastName?.toUpperCase() || user?.nom?.toUpperCase() || 'NoLastName';
    const lang = language?.toUpperCase() || 'NoLang'
    const keyw = keywords?.join( '_' ) || 'NoKeyWords';

    return `ACO_${ firstName }_${ lastName }_CV_${ lang }_${ keyw }.docx`;
}
